import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import RuleFolderIcon from '@mui/icons-material/RuleFolder';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { DASHBOARD_KEYS } from '../../../../platform/widgets/widgetRegistry.js';
import RoleDashboardPage from './RoleDashboardPage';

/**
 * FLS Dashboard — Mindmap branch 2, "Frontline Supervisor / Team Leader"
 *  - Sees NWT dashboard, reviews the crew's OE Conditions at L1, approves up to the DH
 * Widgets (B4): l1-queue, my-nwt-scores, risk-alerts, active-surveys, oe-conditions (crew, P2-26).
 */
function PendingReviewBanner({ trls }) {
  const navigate = useNavigate();
  const pending = (trls || []).filter((t) => t.status === 'submitted' || t.status === 'review_l1');
  if (pending.length === 0) return null;
  return (
    <Card sx={{ mb: 3, bgcolor: '#fff3e0', borderLeft: 6, borderLeftColor: '#ef6c00' }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <RuleFolderIcon sx={{ color: '#ef6c00', fontSize: 32 }} />
          <Box>
            <Typography variant="h6" fontWeight={700}>
              {pending.length} OE Condition{pending.length !== 1 ? 's' : ''} from your NWT awaiting your review
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Verify or adjust severity (I–IV), then approve to send up to your DH.
            </Typography>
          </Box>
        </Box>
        <Button variant="contained" color="warning" endIcon={<ArrowForwardIcon />} onClick={() => navigate('/drew/rollup/review-queue')}>
          Open Review Queue
        </Button>
      </CardContent>
    </Card>
  );
}

function FLSDashboard() {
  return (
    <RoleDashboardPage
      dashboardKey={DASHBOARD_KEYS.drewFls}
      hero={{ icon: SupervisorAccountIcon, title: 'Frontline Supervisor / Team Leader Dashboard', color: '#1565c0' }}
      conditions={{ title: 'OE Conditions', scopeLabel: 'your Natural Work Team' }}
      banner={(role) => <PendingReviewBanner trls={role.trls} />}
    />
  );
}

export default FLSDashboard;
